define('viewModels/privileged/qm/policies/editors/NumberSelectorView',[
    'lib/knockout',
    'viewModels/ViewModel'
], function (ko, ViewModel) {
    'use strict';

    var NumberSelectorView = ViewModel.extend(function (numberSelectorObservable) {
        var self = this;

        self.numberValue = numberSelectorObservable;

        self.numberValue.subscribe(function(newValue) {
            // don't let a user enter something that isn't a number
            // stops letters and non-numeric characters
            if(isNaN(newValue)){
                self.numberValue(1);
            } else {
                self.numberValue(newValue);
            }
        });
    });

    return NumberSelectorView;
});

